<template>
<div>
        <div class="tunnel columns">
        <h2>隧道自动化监测</h2>
        <div class="all">
          <p>
              隧道属于半隐蔽性工程,受运营年限、地质条件、设计施工等因素的影响，经常出现隧道拱顶开裂、边墙开裂、拱顶空洞、衬砌损坏、 隧道渗漏水、隧道冻害、围岩大变形、衬砌厚度薄、混凝土强度低、隧道内空气污染等病害，因此对其进行监测是必要的 
          </p>
        </div>
        <div class="brief_box">

            <div class="title_box row">
                <div class="blue_line"></div>
                <h5>项目基本情况</h5>
            </div>
            <p>监测隧道主体结构和衬砌结构变形和受力状况，确保隧道施工和 运营期间的安全</p>
             
              <div class="title_box row">
                <div class="blue_line"></div>
                <h5>监测参数</h5>
            </div>
            <p>断面收敛（测量机器人/激光测距仪）</p>
            <p>拱顶沉降（测量机器人）</p>
            <p>深层位移（多点位移计）</p>
            <p>接缝位移（裂缝计）</p>
            <p>衬砌内力（钢筋计/锚杆计）</p>
            <p>气象环境（气象传感器）</p>
            <p>外侧土压力（土压力计）</p>
            <p>地震（加速度传感器)</p>

            <div class="title_box row">
                <div class="blue_line"></div>
                <h5>推荐设备</h5>
            </div>
            <p>监测设备：</p>
            <p>Topcon MS系列测量机器人</p>
            <p>Topcon DS系列测量机器人</p>
            <p>RT-LRD系列智能测距仪</p>
            <p>RT-VW-4300振弦式多点位移计</p>
            <p>RT-VW-4100振弦式裂缝计</p>
            <p>RT-VW-2300振弦式钢筋计</p>
            <p>RT2000-WS三参数气象传感器</p>
            <p>RT-VW-2400振弦式土压力计</p>
            <h6>监测终端:</h6>
            <p>RocBox RT2000监测终端</p> 
            <p>RocMIoT监测物联网系列产品</p>  
            <p>振动信号采集仪</p>                
        </div>    
    </div>
     <foot></foot>

</div>

</template>
<style>
.tunnel {
  width: 100%;
  background-color: rgba(245, 245, 245, 1);
}
h2 {
  font-size: 0.36rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(37, 43, 58, 1);
  margin-top: 0.55rem;
  margin-bottom: 0.36rem;
}
.all {
  width: 11.4rem;
  height: 0.4rem;
  background: rgba(255, 255, 255, 1);
  border: 0.01rem solid rgba(221, 221, 221, 1);
  margin: 0 auto;
  padding: 0.3rem;
  font-size: 0.14rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(102, 106, 117, 1);
}
.brief_box {
  width: 12rem;
  background: rgba(255, 255, 255, 1);
  border: 0.01rem solid rgba(221, 221, 221, 1);
  margin-top: 0.2rem;
  margin-bottom: 0.67rem;
  padding-bottom: .64rem;
}
.brief_box p,
 .brief_box h6{
  font-size: 0.14rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(102, 106, 117, 1);
  padding-left: 0.4rem;
  padding-top: 0.1rem;
}
.brief_box h6{
    padding-top: .3rem;
}
.title_box {
  margin-left: 0.4rem;
  margin-top: 0.37rem;
  font-size: 0.16rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(37, 43, 58, 1);
  line-height: 0.2rem;
}
.blue_line {
  width: 0.03rem;
  height: 0.2rem;
  background: rgba(67, 148, 208, 1);
  margin-right: 0.1rem;
}
</style>

<script>
import footer from "../../common/footer";
export default {
  data() {
    return {};
  },
  components: {
    foot: footer
  }
};
</script>



// WEBPACK FOOTER //
// src/homepages/solutionpage/tunnel.vue